import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useLeadStore, useTenantInMarketStore } from '../..';
import useLeadsInsideShape from '../../hooks/useLeadsInsideShape';
import useLeadsWithFocusArea from '../../hooks/useLeadsWithFocusArea';
import useLeadsWithGlobalFilters from '../../hooks/useLeadsWithGlobalFilters';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import LeadsGrid from '../leads/LeadsGrid';

function TenantInMarketDetailsLeadsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leadStore = useLeadStore();
    const tenantInMarketStore = useTenantInMarketStore();
    const tenantInMarket = useMemo(() => computed(() => tenantInMarketStore.tenantsInMarket.find(tim => tim.id.toString() === id)!), [id]).get();
    const allLeads = useLeadsWithFocusArea(useLeadsWithGlobalFilters(useLeadsInsideShape(leadStore.leads, tenantInMarket.shape)));
    const buildNeeded = useMemo(() => (tenantInMarket.buildingAreaMin + tenantInMarket.buildingAreaMax) / 2, [tenantInMarket]);
    const leads = useMemo(() => {
        if (!buildNeeded)
            return allLeads.filter(l => !l.buildingSize);
        return allLeads.filter(l => !!l.buildingSize);
    }, [allLeads, buildNeeded]);

    useEffect(() => setEntityCount(leads.length), [leads]);

    if (!visible)
        return null;

    return (
        <LeadsGrid leads={leads} tenantInMarket={tenantInMarket} />
    );
}

export default observer(TenantInMarketDetailsLeadsTab);